import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKInput from "components/MKInput";
import MKButton from "components/MKButton";
import CoverLayout from "pages/Authentication/components/CoverLayout";
import { createUser } from "api/RestHelper";
import useLoader from "hooks/useLoader";
import bgImage from "assets/PhotoReal_tarot_question_5.jpg";

function Cover() {
  const navigate = useNavigate();
  const { loaderState, setLoader, closeLoader } = useLoader();

  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [phoneError, setPhoneError] = useState("");

  const validatePhoneNumber = (phoneNumber) => {
    // Check if phone number is a valid Turkish number (10 digits, starts with 5)
    const regex = /^5\d{9}$/;
    return regex.test(phoneNumber);
  };

  const onSubmit = (e) => {
    e.preventDefault();

    if (!validatePhoneNumber(phone)) {
      setPhoneError("Lütfen geçerli bir cep telefonu numarası girin.");
      return;
    }

    setLoader({ open: true });
    const user = {
      displayName: `${firstname} ${lastname}`,
      firstname,
      lastname,
      roles: ["user"],
      email,
      phone,
    };
    createUser(user, () => {
      closeLoader();
      navigate("/giris", { replace: true });
    });
  };

  return (
    <CoverLayout image={bgImage}>
      {loaderState.open ? (
        <MKBox sx={{ display: "flex" }}>
          <CircularProgress />
        </MKBox>
      ) : (
        <Card>
          <MKBox p={3}>
            <MKBox onSubmit={onSubmit} component="form" role="form">
              <MKBox mb={2}>
                <MKInput
                  value={firstname}
                  onChange={(event) => setFirstname(event.target.value)}
                  type="text"
                  label="İsim"
                  fullWidth
                />
              </MKBox>
              <MKBox mb={2}>
                <MKInput
                  value={lastname}
                  onChange={(event) => setLastname(event.target.value)}
                  type="text"
                  label="Soyisim"
                  fullWidth
                />
              </MKBox>
              <MKBox mb={2}>
                <MKInput
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  type="email"
                  label="Email"
                  fullWidth
                />
              </MKBox>
              <MKBox mb={2}>
                <MKInput
                  value={phone}
                  onChange={(event) => {
                    setPhone(event.target.value);
                    setPhoneError(""); // Clear error on change
                  }}
                  type="text"
                  label="Telefon Numarası"
                  fullWidth
                  error={!!phoneError}
                  helperText={phoneError}
                />
              </MKBox>
              <MKBox mt={3} mb={1}>
                <MKButton type="submit" variant="gradient" color="info" fullWidth>
                  Hesap oluştur
                </MKButton>
              </MKBox>
              <MKBox mt={3} mb={1} textAlign="center">
                <MKTypography variant="button" color="text">
                  Zaten hesabınız var mı?{" "}
                  <MKTypography
                    component={Link}
                    to="/authentication/sign-in/cover"
                    variant="button"
                    color="info"
                    fontWeight="medium"
                    textGradient
                  >
                    Giriş Yap
                  </MKTypography>
                </MKTypography>
              </MKBox>
            </MKBox>
          </MKBox>
        </Card>
      )}
    </CoverLayout>
  );
}

export default Cover;
